import React, {Component} from 'react';
import CRUDTable from "../common/htmlElements/TableComponent/subTableComponents/CRUDTable";
import {Link} from "react-router-dom";
import {injectIntl} from "react-intl";
import "./ShowPreferencesTable.css";

class ShowPreferencesTable extends Component {

    getPriorityMeta = priorityLevel => {
        const isFrench = this.props.intl.locale === "fr";
        const priority = Number(priorityLevel);

        if (!Number.isFinite(priority)) {
            return {
                label: isFrench ? "Personnalisee" : "Custom",
                tone: "custom"
            };
        }

        if (priority <= 10 || priority === 1) {
            return { label: isFrench ? "Tres elevee" : "Very high", tone: "critical" };
        }

        if (priority <= 20 || priority === 2) {
            return { label: isFrench ? "Elevee" : "High", tone: "high" };
        }

        if (priority <= 30 || priority === 3) {
            return { label: isFrench ? "Moyenne" : "Medium", tone: "medium" };
        }

        if (priority <= 40 || priority === 4) {
            return { label: isFrench ? "Faible" : "Low", tone: "low" };
        }

        if (priority <= 50 || priority === 5) {
            return { label: isFrench ? "Tres faible" : "Very low", tone: "muted" };
        }

        return {
            label: isFrench ? "Personnalisee" : "Custom",
            tone: "custom"
        };
    };

    renderBooleanBadge = (value, trueLabel, falseLabel) => (
        <span className={value ? "preferenceTableBadge is-true" : "preferenceTableBadge is-false"}>
            {value ? trueLabel : falseLabel}
        </span>
    );

    columns = [
        {path:"id",label:this.props.intl.formatMessage({id: "table.preferences.id.short"})},
        {path:"active",label:this.props.intl.formatMessage({id: "table.preferences.active.short"}), content: preference => (
                this.renderBooleanBadge(preference.active, this.props.intl.locale === "fr" ? "Active" : "Active", this.props.intl.locale === "fr" ? "Inactive" : "Inactive")
            )},
        {path:"fr",label:this.props.intl.formatMessage({id: "table.preferences.fr.short"})},
        {path:"en",label:this.props.intl.formatMessage({id: "table.preferences.en.short"})},
        {path:"clientOnly",label:this.props.intl.formatMessage({id: "table.preferences.clientOnly.short"}), content: preference => (
                this.renderBooleanBadge(preference.clientOnly, this.props.intl.locale === "fr" ? "Oui" : "Yes", this.props.intl.locale === "fr" ? "Non" : "No")
            )},
        {path:"sponsorOnly",label:this.props.intl.formatMessage({id: "table.preferences.sponsorOnly.short"}), content: preference => (
                this.renderBooleanBadge(preference.sponsorOnly, this.props.intl.locale === "fr" ? "Oui" : "Yes", this.props.intl.locale === "fr" ? "Non" : "No")
            )},
        {path:"priorityLevel",label:this.props.intl.formatMessage({id: "table.preferences.priorityLevel.short"}), content: preference => {
                const meta = this.getPriorityMeta(preference.priorityLevel);

                return (
                    <div className="preferencePriorityCell">
                        <span className={`preferencePriorityBadge tone-${meta.tone}`}>{preference.priorityLevel}</span>
                        <span className="preferencePriorityLabel">{meta.label}</span>
                    </div>
                );
            }},
        {key:"edit", content: preference => (
                <Link className="preferenceEditLink" to={`./manage-preferences/${preference.id}`} >{this.props.intl.formatMessage({id: "table.preferences.editLink"})}</Link>
            )}
    ];

    render() {
        const {preferencesList, onSort, sortColumn} = this.props;

        return (
            <CRUDTable
                columns={this.columns}
                data = {preferencesList}
                sortColumn={sortColumn}
                onSort={onSort}
                isLoading={this.props.isLoading}
                locale = {this.props.intl}
            />
        );
    }
}

export default injectIntl(ShowPreferencesTable);
